import React from "react";
import MachineMovementReport from "../Reports/MachineAnalytics/MachineMovementReport";
import usePreferredLanguage from "../../utilities/usePreferredLanguage";
import { translateUiText } from "../../utilities/siteTranslations";

const MachineMovements = () => {
  const storedUser = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const roleUid = String(storedUser?.data?.adminUser?.role?.uid || "");
  const isOperator = roleUid === "operator";
  const preferredLanguage = usePreferredLanguage();
  const t = (value) => translateUiText(value, preferredLanguage);

  return (
    <div className="p-4">
      <div className="mb-4">
        <h2>{t("Machine Movement Reports")}</h2>
        <p className="text-color-secondary">
          {isOperator
            ? preferredLanguage === "es"
              ? "Da seguimiento a las demostraciones asignadas."
              : "Track assigned demonstrations."
            : preferredLanguage === "es"
              ? "Da seguimiento a instalaciones, retiros, intercambios, demostraciones e inspecciones de sitio."
              : "Track installations, removals, exchanges, demonstrations, and site inspections."}
        </p>
      </div>
      <MachineMovementReport demonstrationsOnly={isOperator} />
    </div>
  );
};

export default MachineMovements;
